// extracted by mini-css-extract-plugin
export default {"linkListElement":"LinkListElement_linkListElement__GAMW1"};